export const dashboard = {
	/**
	* Gets the programmatic name of the entire locale, with the language, 
	*	country and variant separated by underbars. The Language is always lower case, 
	*	and country is always upper case. If the language is missing, 
	*	the string will begin with an underscore character. 
	*	If both the language and country fields are missing, 
	*	this function will return the empty string, 
	*	even if the variant field is filled in (you cannot have a locale with just a variant-- 
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
		dashboard:'Dashboard',
		total_installed_device:'Total No. of Installed Device',
		total_active_device:'Total No. of Active Device',
		total_inactive_device:'Total No. of InActive Device',
		active_device:'Active device',
		inactive_device:'Inactive device',
		tampering:'Tampering',
		total_consumers:'Total No. Of Consumers',
		monthly_planned_consumption:'Monthly Planned Consumption',
		monthly_actual_consumption:'Monthly Actual Consumption',
		tamper:'Tamper',
		battery:'Battery',
		faulty_device:'Faulty Device',
		missing_payload:'Missing Payload',
		offline_device:'Offline Device',
		alerts:'Alerts',
		meter_health:'Meter Health',
		battery_status:'Battery Status',
		critical:'Critical',
		low:'Low',
		healthy:'Healthy',
		planned_vs_actual:'Planned vs Actual',
		consumption:'Consumption',
		peak_flow:'Peak Flow',
    },
  
	ar: {
		dashboard:'لوحة القيادة',
		total_installed_device:'العدد الإجمالي للجهاز المثبت',
		total_active_device:'العداد الإجمالي للأجهزة النشطة',
		total_inactive_device:'العدد الإجمالي للأجهزة غير النشطة',
		active_device:'جهاز نشط',
		inactive_device:'جهاز غير نشط',
		tampering:'التلاعب',
		total_consumers:'إجمالي عدد المستهلكين',
		monthly_planned_consumption:'الاستهلاك الشهري المخطط له',
		monthly_actual_consumption:'الاستهلاك الفعلي الشهري',
		tamper:'التلاعب',
		battery:'البطارية',
		faulty_device:'الأجهزة المعيبة',
		missing_payload:'الحمولة المفقودة',
		offline_device:'جهاز غير متصل بالإنترنت',
		alerts:'الاشعارات',
		meter_health:'صحة العدادات',
		battery_status:'حالة البطارية',
		critical:'حرج',
		low:'ضعيف',
		healthy:'صحي',
		planned_vs_actual:'المخطط ضد الفعلي',
		consumption:'استهلاك',
		peak_flow:'قمة التدفق',
    },
	
	

	
}